<div class="filter" [hidden]="!isOpenFilter">
  <div class="filter__fields-group">
    <div>
      <app-field>
        <label><span class="title title--s title--required">Начало периода</span></label>
        <app-date-time-picker
          [initDate]="ticketsPeriodFilter.dateRange.startDate.initDate"
          [isShowTimepicker]="false"
          [datepickerName]="'startTemplatePeriodDate'"
          [options]="ticketsPeriodFilter.dateRange.startDate.options"
          (dateCallback)="onChangeStartTemplatePeriodDate($event)"
        ></app-date-time-picker>
      </app-field>
    </div>
    <div class="mt-16">
      <app-field>
        <label><span class="title title--s title--required">Конец периода</span></label>
        <app-date-time-picker
          [initDate]="ticketsPeriodFilter.dateRange.endDate.initDate"
          [isShowTimepicker]="true"
          [datepickerName]="'endTemplatePeriodDate'"
          [options]="ticketsPeriodFilter.dateRange.endDate.options"
          [defaultTime]="endDateDefaultTime"
          (dateCallback)="onChangeEndTemplatePeriodDate($event)"
        ></app-date-time-picker>
      </app-field>
    </div>
  </div>
  <div class="filter__fields-group-delimiter"></div>
  <div class="filter__fields-group">
    <div>
      <app-field>
        <label>Район</label>
        <app-select-multiple
          [initBy]="ticketsPeriodFilter.districtsSelected"
          [initByKey]="'d_id'"
          [items]="ticketsPeriodFilter.data.districts"
          [textKey]="'full_name'"
          (callback)="onChangeDistricts($event)"
          [defaultText]="'Выберите район'"
        ></app-select-multiple>
      </app-field>
    </div>
    <div class="mt-16">
      <app-field>
        <label>Адрес</label>
        <input class="input-text" type="text" id="addressField" placeholder="Введите адрес" [(ngModel)]="ticketsPeriodFilter.address" />
      </app-field>
    </div>
  </div>
  <div class="filter__fields-group-delimiter"></div>
  <div class="filter__fields-group">
    <div>
      <app-field>
        <label>Статус в ВК</label>
        <app-select-multiple
          [initBy]="ticketsPeriodFilter.ticketsVkStatusesSelected"
          [initByKey]="'id'"
          [items]="ticketsPeriodFilter.data.ticketsVkStatuses"
          [textKey]="'name'"
          (callback)="onChangeVkStatues($event)"
        ></app-select-multiple>
      </app-field>
    </div>
    <div class="mt-16">
      <app-field>
        <label>Статус в HD</label>
        <app-select-multiple
          [initBy]="ticketsPeriodFilter.ticketHdStatusesSelected"
          [initByKey]="'id'"
          [items]="ticketsPeriodFilter.data.ticketsHdStatuses"
          [textKey]="'name'"
          (callback)="onChangeHdStatues($event)"
        ></app-select-multiple>
      </app-field>
    </div>
  </div>
  <ng-container *ngIf="isGRSUser()">
    <div class="filter__fields-group-delimiter"></div>
    <div class="filter__fields-group">
      <div>
        <app-field>
          <label>Тип ГП</label>
          <app-select-multiple
            [initBy]="ticketsPeriodFilter.typeGPSelected"
            [initByKey]="'id'"
            [items]="ticketsPeriodFilter.data.typeGPs"
            [textKey]="'name'"
            [defaultText]="'Выберите тип'"
            (callback)="onChangeTypeGPs($event)"
          ></app-select-multiple>
        </app-field>
      </div>
      <div class="mt-16">
        <app-field>
          <label>Подтип ГП</label>
          <app-select-multiple
            [initBy]="ticketsPeriodFilter.subtypeGPSelected"
            [initByKey]="'id'"
            [items]="ticketsPeriodFilter.data.subtypeGPs"
            [textKey]="'subtype'"
            [defaultText]="'Выберите подтип'"
            (callback)="onChangeSubtypeGPs($event)"
          ></app-select-multiple>
        </app-field>
      </div>
    </div>
  </ng-container>
  <ng-container *ngIf="isGRSUser()">
    <div class="filter__fields-group-delimiter"></div>
    <div class="filter__fields-group">
      <div>
        <app-field>
          <label>Группа ответственного</label>
          <app-select-multiple
            [initBy]="ticketsPeriodFilter.responsibleGroupsSelected"
            [initByKey]="'g_id'"
            [items]="ticketsPeriodFilter.data.responsibleGroups"
            [textKey]="'g_name'"
            [defaultText]="'Выберите группу'"
            (callback)="onChangeResponsibleGroups($event)"
          ></app-select-multiple>
        </app-field>
      </div>
      <div class="mt-16">
        <app-field>
          <label>Ответственный</label>
          <app-select-multiple
            [initBy]="ticketsPeriodFilter.responsibleUsersSelected"
            [initByKey]="'u_login'"
            [items]="ticketsPeriodFilter.data.responsibleUsers"
            [textKey]="'u_name'"
            [defaultText]="'Выберите ответственного'"
            (callback)="onChangeResponsibleUsers($event)"
          ></app-select-multiple>
        </app-field>
      </div>
    </div>
  </ng-container>
  <ng-container>
    <div class="filter__fields-group-delimiter"></div>
    <div class="filter__fields-group">
      <div *ngIf="!isGRSUser()">
        <app-field>
          <label>Тип</label>
          <app-select-multiple
            [initBy]="ticketsPeriodFilter.ticketTypesSelected"
            [initByKey]="'id'"
            [items]="ticketsPeriodFilter.data.ticketsTypes"
            [textKey]="'name'"
            (callback)="onChangeTicketsTypes($event)"
            [defaultText]="'Выберите тип'"
          ></app-select-multiple>
        </app-field>
      </div>
      <ng-container *ngIf="isGRSUser()">
        <ng-container *ngTemplateOutlet="brigadeAssign"></ng-container>
      </ng-container>
      <div class="mt-16">
        <app-field>
          <label>Номер</label>
          <input class="input-text" type="text" id="ticketNumberField" placeholder="Введите номер" [(ngModel)]="ticketsPeriodFilter.ticketNumber" />
        </app-field>
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="!isGRSUser()">
    <div class="filter__fields-group-delimiter"></div>
    <div class="filter__fields-group">
      <ng-container *ngTemplateOutlet="brigadeAssign"></ng-container>
    </div>
  </ng-container>

  <ng-container>
    <div class="filter__fields-group-delimiter"></div>

    <div class="filter__actions">
      <div class="grid grid--va-middle grid--no-wrap">
        <div class="grid__box grid__box--size-min">
          <button
            class="button"
            type="button"
            (click)="onApplyFilter()"
            id="appApplyTicketFilter"
            [disabled]="
              !ticketsPeriodFilter.dateRange.startDate.dateObj ||
              !ticketsPeriodFilter.dateRange.startDate.dateObj.dateMillis ||
              !ticketsPeriodFilter.dateRange.endDate.dateObj ||
              !ticketsPeriodFilter.dateRange.endDate.dateObj.dateMillis
            "
          >
            Применить
          </button>
        </div>
        <div class="grid__box grid__box--size-min">
          <button
            class="ctrl link link--dotted-blue-dark"
            (click)="onResetFilter()"
            id="appResetTicketFilter"
            [disabled]="
              !ticketsPeriodFilter.dateRange.startDate.dateObj ||
              !ticketsPeriodFilter.dateRange.startDate.dateObj.dateMillis ||
              !ticketsPeriodFilter.dateRange.endDate.dateObj ||
              !ticketsPeriodFilter.dateRange.endDate.dateObj.dateMillis
            "
          >
            Сбросить
          </button>
        </div>
      </div>
      <div class="filter__export">
        <button
          class="ctrl link link--dotted-blue-dark"
          type="button"
          (click)="onExport()"
          id="appExportTicketFilter"
          [disabled]="
            !ticketsPeriodFilter.dateRange.startDate.dateObj ||
            !ticketsPeriodFilter.dateRange.startDate.dateObj.dateMillis ||
            !ticketsPeriodFilter.dateRange.endDate.dateObj ||
            !ticketsPeriodFilter.dateRange.endDate.dateObj.dateMillis
          "
        >
          Экспорт
        </button>
      </div>
      <div class="collapse__ctrl" (click)="onToggleFilter()">
        <app-icon [glyph]="'arrow-top'" [size]="'14'" [class]="'icon--va-middle'"></app-icon>
      </div>
    </div>
  </ng-container>

  <ng-template #brigadeAssign>
    <app-field>
      <label>Назначена на бригаду</label>
      <app-select-multiple
        [initBy]="ticketsPeriodFilter.brigadesSelected"
        [initByKey]="'id'"
        [items]="ticketsPeriodFilter.data.brigades"
        [textKey]="'brigade_name'"
        (callback)="onChangeBrigades($event)"
        [defaultText]="'Выберите бригаду'"
      ></app-select-multiple>
    </app-field>
  </ng-template>
</div>

<div class="filter filter--close" [hidden]="isOpenFilter">
  <div class="font-weight-bold color-blue-dark">Фильтр по заявкам</div>
  <div class="collapse__ctrl" (click)="onToggleFilter()">
    <app-icon [glyph]="'arrow-down'" [size]="'14'" [class]="'icon--va-middle'"></app-icon>
  </div>
</div>
